import { truncateText } from '../../utilities';
import styles from './sankey-chart.module.css';
import type { SankeyNodeValidated } from './types';

const LABEL_FONT_SIZE = 12;
const VALUE_FONT_SIZE = 11;
export const LABEL_PADDING = 8;

type NodeLabelProps = {
  node: SankeyNodeValidated;
  centerY: number;
  isFirstColumn: boolean;
  isLastColumn: boolean;
  sideLabelMaxWidth: number;
  interiorLabelMaxWidth: number;
  label: string;
  value?: string;
};

/** Outer-column labels sit in the side margins; interior labels center above the bar. */
export const NodeLabel = ({
  node,
  centerY,
  isFirstColumn,
  isLastColumn,
  sideLabelMaxWidth,
  interiorLabelMaxWidth,
  label,
  value,
}: NodeLabelProps) => {
  if (isFirstColumn || isLastColumn) {
    const x = isFirstColumn ? node.x0 - LABEL_PADDING : node.x1 + LABEL_PADDING;
    const textAnchor = isFirstColumn ? 'end' : 'start';
    const testId = isFirstColumn ? 'sankey-source-node' : 'sankey-target-node';
    const truncated = truncateText({
      text: label,
      maxWidth: sideLabelMaxWidth,
      fontSize: LABEL_FONT_SIZE,
    });
    return (
      <text
        x={x}
        y={centerY}
        textAnchor={textAnchor}
        dominantBaseline="middle"
        fontSize={LABEL_FONT_SIZE}
        className={styles.label}
        data-testid={testId}
      >
        <title>{label}</title>
        {truncated}
        {value !== undefined && (
          <tspan
            x={x}
            dy="1.2em"
            fontSize={VALUE_FONT_SIZE}
            className={styles.value}
          >
            {value}
          </tspan>
        )}
      </text>
    );
  }

  const centerX = (node.x0 + node.x1) / 2;
  const truncated = truncateText({
    text: label,
    maxWidth: interiorLabelMaxWidth,
    fontSize: LABEL_FONT_SIZE,
  });
  return (
    <text
      x={centerX}
      y={node.y0 - 4}
      textAnchor="middle"
      fontSize={LABEL_FONT_SIZE}
      className={styles.label}
      data-testid="sankey-center-node"
    >
      <title>{label}</title>
      {truncated}
      {value !== undefined && ` (${value})`}
    </text>
  );
};
